module.exports = __webpack_public_path__ + "static/media/cerrado-thumbnail.3fcd2871.webp";